import React, { useEffect, useState } from "react";

export interface AlertProps {
  containerClassName?: string;
  type?: "default" | "warning" | "info" | "success" | "error";
}

export const Alert: React.FC<AlertProps> = ({
  children = "Alert Text",
  containerClassName = "",
  type = "default",
}) => {
  const [hidden, setHidden] = useState<boolean>(false);

  useEffect(() => {
    setTimeout(() => {
      setHidden(true);
    }, 4000);
  }, []);
  let classes = containerClassName;
  switch (type) {
    case "default":
      classes += "text-black bg-red-300";
      break;
    case "info":
      classes += " bg-blue-300 text-status-info";
      break;
    case "success":
      classes += " bg-green-300 text-black";
      break;
    case "error":
      classes += " bg-red-300 text-status-error";
      break;
    case "warning":
      classes += " bg-yellow-300 text-status-warning";
      break;
    default:
      break;
  }

  return (
    <div className={`flex justify-center items-center ${hidden && "hidden"}`}>
      <div
        className={`max-w-md mx-auto  flex justify-center items-center text-center px-6 py-6  rounded-lg ${classes} font-medium`}
      >
        <i className="pe-7s-info text-2xl mr-2"></i>
        {children}
      </div>
      {/* <ButtonClose
        className="absolute top--4 right--4 bg-white rounded-full"
        onClick={() => setHidden(true)}
      /> */}
    </div>
  );
};
